import LineInterface from 'app/interfaces/LineInterface';

export const isTotalLine = (line: LineInterface): boolean => line['total_rounds?'];
